
export default {
    name:'cal-rewards-program-section',
    props:['rewardsListContent']

}
